<template>
    <div>
        <pagehead />
        <div class="bread">
            <div class="_content">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item class="unbold" :to="{ path: '/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item class="unbold" :to="{ path: this.$route.query.source == 'social' ? '/social' : '/news' }">{{source}}</el-breadcrumb-item>
                    <el-breadcrumb-item class="bold">文章详情</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="essay _content" v-if="newsData">
            <div class="title_font">
                {{ newsData.title }}
            </div>
            <div class="cerated_time_font">{{ newsData.createdTime }}</div>
            <div class="content" v-html="newsData.content">
            </div>
        </div>
        <pagefooter />
        <el-backtop :right="50" :bottom="80">
            <div class="backup-icon"></div>
        </el-backtop>
    </div>

</template>
<script>
import { WOW } from 'wowjs'
import '@/assets/styles/common.css'
import pagehead from '@/component/pagehead.vue'
import pagefooter from '@/component/pagefooter.vue'
import { getNews } from '@/api/news'
export default {
    name: "newsdetail",
    components: { pagehead, pagefooter },
    data() {
        return {
            newsData: null,
            source: ''
        };
    },
    created() {
        this.source = this.$route.query.source == "social" ? '社会责任' : '新闻中心'
        this.getNewsInfo();
    },
    mounted() {
        new WOW({ live: false }).init();
    },
    methods: {
        getNewsInfo() {
            getNews({id: this.$route.query.id}).then(response => {
                this.newsData = response.data;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.bread {
    background-color: #fafafa;
    height: 52px;
    display: flex;
    align-items: center;
}

.essay {
    background-color: #fafafa;
    margin: 20px auto;
    padding: 30px;
}

.title_font {
    color: rgba(0, 0, 0, 0.9);
    font-size: 28px;
    font-weight: bold;
    text-align: left;
    line-height: 36px;
}

.cerated_time_font {
    color: rgba(0, 0, 0, 0.4);
    font-size: 14px;
    line-height: 22px;
    margin: 16px 0 30px;
}

.content {
    color: rgba(0, 0, 0, 0.9);
    font-size: 16px;
    line-height: 28px;
}

.el-breadcrumb .bold ::v-deep .el-breadcrumb__inner {
    font-weight: bold;
}

.el-breadcrumb .unbold ::v-deep .el-breadcrumb__inner {
    font-weight: normal;
}
</style>